import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import navConfig from "../config/navConfig";
import "./Navbar.css";
import homeIcon from "./assets/homeicon.png";
import { useMsal } from "@azure/msal-react";

const slugify = (str) =>
  decodeURIComponent(str)
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, "")
    .trim()
    .replace(/\s+/g, "-");

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { instance } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect();
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleHome = () => {
    navigate("/");
  };

  const closeTimeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (closeTimeoutRef.current) clearTimeout(closeTimeoutRef.current);
    };
  }, []);

  return (
    <div
      className={`floating-navbar ${isOpen ? "open" : ""}`}
      onMouseEnter={() => {
        if (closeTimeoutRef.current) {
          clearTimeout(closeTimeoutRef.current);
        }
        setIsOpen(true);
      }}

      onMouseLeave={() => {
        closeTimeoutRef.current = setTimeout(() => {
          setIsOpen(false);
        }, 200);
      }}
    >
      <div className="hamburger-menu">
        <img src={homeIcon} alt="Reports" className="home-icon" />
        <div className="dropdown-text">Reports</div>
      </div>

      {isOpen && (
        <div className="dropdown-menu">
          <div className="navbar-top-buttons">
            <button className="nav-btn back" onClick={handleBack}>
              <span>🔙</span> Back
            </button>
            <button className="nav-btn home" onClick={handleHome}>
              <span>🏠</span> Home
            </button>
            <button className="nav-btn logout" onClick={handleLogout}>
              Logout
            </button>
          </div>

          <div className="scroll-area">
            {navConfig.map((dashboard, dIndex) => (
              <div className="dashboard-column" key={`${slugify(dashboard.label)}-${dIndex}`}>
                <div className="parent-label">{dashboard.label}</div>
                <div className="child-group">
                  {dashboard.reports.map((report, rIndex) => (
                    <div key={`${slugify(report.name)}-${rIndex}`}>
                      <div className="child-label">{report.name}</div>
                      <div className="grandchild-group">
                        {report.pages.map((page, pIndex) => {
                          const isActive = location.pathname === page.route;
                          return (
                            <div
                              key={`${slugify(page.name)}-${pIndex}`}
                              className="grandchild-label"
                              style={{ fontWeight: isActive ? "bold" : "normal" }}
                              onClick={() => navigate(page.route)}
                            >
                              {page.name}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

        </div>
      )}
    </div>
  );
};

export default Navbar;
